<template>
    <div class="answer answer-col account-item">
        <div class="row">
            <div class="col-md-12">
                <p class="sub-question" v-if="value.individual_id === personOne.id">
                    At what age will you claim your pension?
                </p>
                <p class="sub-question" v-else>
                    At what age will {{ personTwo.name }} claim their pension?
                </p>
                <v-btn icon small class="account-delete" @click="$emit('delete', value)">
                    <v-icon dark>mdi-delete</v-icon>
                </v-btn>
                <div class="sub-answer">
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.start_year_formula === 'specific_year' && value.specific_year_to_start === 0 }" @click="value.start_year_formula = 'specific_year'; value.specific_year_to_start = 0">Now</span>
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.start_year_formula === 'retirement' }" @click="value.start_year_formula = 'retirement'">Retirement</span>
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.start_year_formula === 'life_exp' }" @click="value.start_year_formula = 'life_exp'">Life Expectancy</span>
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.start_year_formula === 'specific_age' }" @click="value.start_year_formula = 'specific_age'">Specific Age</span>
                </div>
            </div>
        </div>

        <div class="row" v-if="value.start_year_formula === 'specific_age'">
            <div class="col-md-12">
                <label class="label-slider" v-if="value.individual_id === personOne.id">
                    When I am&nbsp;<span>{{ value.specific_age_to_start }}</span>
                </label>
                <label class="label-slider" v-else>
                    When {{ personTwo.name }} is&nbsp;<span>{{ value.specific_age_to_start }}</span>
                </label>
                <v-slider
                    v-model="value.specific_age_to_start"
                    class="align-center"
                    :max="100"
                    :min="min"
                    hide-details
                    track-color="#e0e0e0"
                >
                </v-slider>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                 <v-text-field
                    label="How much monthly $" v-model="value.value" class="inputNumber"
                ></v-text-field>
            </div>

            <div class="col-md-4 offset-md-1">
                <v-checkbox
                v-model="showSurvivorship"
                :label="`Has survivorship`" class="checkboxBigger"
                ></v-checkbox>
            </div>

            <div class="col-md-3" v-if="showSurvivorship">
                <v-text-field
                    label="Percentage %" v-model="value.pension_survivorship" class="inputNumber"
                ></v-text-field>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'Pension',
        props: [
            'value'
        ],
        data() {
            return {
                showSurvivorship: false,
            }
        },
        created() {
            if (this.value.pension_survivorship != 0) {
                this.showSurvivorship = true;
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
                'personTwoExists',
            ]),
            min() {
                if (!this.value) {
                    return 0;
                }

                if (this.value.individual_id === this.personOne.id) {
                    return this.personOne.current_age;
                }

                return this.personTwo.current_age;
            }
        }
    }
</script>
